import { Box, Button, Card, Typography, IconButton } from "@mui/material";
import DropdownPlatform from "../DropdownPlatform";
import { useEffect, useState } from "react";
import { PlatformOptions } from "../utils/Contants";
import muiStyles from "../styles/muiStyles";
import CustomTypography from "../../../Components/Typography";
import InputField from "../../../Components/InputField";
import { useTranslation } from "react-i18next";

const CommunityLinks = ({
  socialPlatformLinks,
  setSocialPlatformLinks,
  disableFields,
}) => {
  const { t } = useTranslation(["page-community-settings", "components"]);

  const [newPlatform, setNewPlatform] = useState({
    type: "WHATSAPP",
    link: "",
  });
  const [error, setError] = useState("");

  const {
    socialIconStyles,
    cardStyles,
    subheadingBoxStyles,
    descriptionTextStyles,
    newPlatformContainerStyles,
    platformLabelStyles,
    addPlatformButtonStyles,
    existingPlatformsContainerStyles,
    existingPlatformBoxStyles,
    platformIconBoxStyles,
    platformTextStyles,
    linkBoxStyles,
    linkTextStyles,
    errorTextStyles,
  } = muiStyles;

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const addNewPlatform = () => {
    if (!newPlatform.link.trim()) {
      setError(t("connect_your_community.error_empty"));
      return;
    }

    if (!isValidUrl(newPlatform.link)) {
      setError(t("connect_your_community.error_invalid"));
      return;
    }

    const updatedLinks = [...socialPlatformLinks, newPlatform];
    setSocialPlatformLinks(updatedLinks);
    setError("");
  };

  const deleteSocialPlatform = (platform) => {
    const socialLinks = socialPlatformLinks.filter((item) => item !== platform);
    setSocialPlatformLinks(socialLinks);
  };

  const handleLinkChange = (e) => {
    setNewPlatform((prev) => ({ ...prev, link: e.target.value }));
    if (error) setError("");
  };

  const handlePlatformChange = (type) => {
    setNewPlatform((prev) => ({ ...prev, type: type }));
  };

  useEffect(() => {
    const selectedTypes = socialPlatformLinks.map((item) => item.type);

    if (!selectedTypes.includes("WHATSAPP")) {
      setNewPlatform({ type: "WHATSAPP", link: "" });
      return;
    }

    const availableOption = PlatformOptions.find(
      (opt) => !selectedTypes.includes(opt.value)
    );

    if (availableOption) {
      setNewPlatform({
        type: availableOption.value,
        text: t(availableOption.text, { ns: "components" }),
        link: "",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socialPlatformLinks]);

  const availablePlatformOptions = PlatformOptions.filter(
    (opt) => !socialPlatformLinks.some((item) => item.type === opt.value)
  );

  return (
    <Card sx={{ ...cardStyles, pb: "0px" }}>
      <CustomTypography type="subheading">
        {t("connect_your_community.title")}
      </CustomTypography>

      <Box sx={subheadingBoxStyles}>
        <Typography color="rgba(47, 43, 61, 0.9)" sx={descriptionTextStyles}>
          {t("connect_your_community.sub_title")}
        </Typography>
      </Box>

      {availablePlatformOptions.length > 0 ? (
        <Box sx={{ mb: { xs: "32px", sm: "24px" } }}>
          <Box sx={newPlatformContainerStyles}>
            <Box
              sx={{
                opacity: disableFields ? 0.5 : 1,
                pointerEvents: disableFields ? "none" : "auto",
              }}
            >
              <Typography
                color="rgba(47, 43, 61, 0.9)"
                sx={platformLabelStyles}
              >
                {t("connect_your_community.platform")}
              </Typography>

              <Box sx={{ mt: "8px" }}>
                <DropdownPlatform
                  platform={newPlatform}
                  changePlatform={handlePlatformChange}
                  existingPlatforms={socialPlatformLinks}
                  disabled={disableFields}
                />
              </Box>
            </Box>

            <InputField
              label={t("connect_your_community.platform_link")}
              value={newPlatform.link}
              onChange={handleLinkChange}
              placeholder={t("connect_your_community.platform_placeholder")}
              fullWidth
              disabled={disableFields}
            />

            <Button
              variant="contained"
              onClick={addNewPlatform}
              sx={addPlatformButtonStyles}
              disabled={!newPlatform.link.trim() || disableFields}
            >
              {t("connect_your_community.add_platform")}
            </Button>
          </Box>

          {error && (
            <Typography color="error" sx={errorTextStyles}>
              {error}
            </Typography>
          )}
        </Box>
      ) : null}

      {socialPlatformLinks.length > 0 ? (
        <Box sx={existingPlatformsContainerStyles}>
          {socialPlatformLinks.map((item, index) => {
            const selectedPlatform = PlatformOptions.find(
              (option) => option.text.toLowerCase() === item.type.toLowerCase()
            );
            return (
              <Box key={index} sx={existingPlatformBoxStyles}>
                <Box sx={platformIconBoxStyles}>
                  <img
                    src={selectedPlatform?.iconPath}
                    alt="icon"
                    style={{ ...socialIconStyles }}
                  />
                  <Typography
                    color="rgba(47, 43, 61, 0.9)"
                    sx={platformTextStyles}
                  >
                    {selectedPlatform?.text}
                  </Typography>
                </Box>

                <Box sx={linkBoxStyles}>
                  <Typography color="rgba(47, 43, 61, 0.9)" sx={linkTextStyles}>
                    {item.link}
                  </Typography>

                  <IconButton
                    onClick={() => deleteSocialPlatform(item)}
                    sx={{ visibility: disableFields ? "hidden" : "visible" }}
                  >
                    <img
                      src="/icons/delete-icon.svg"
                      alt="delete"
                      style={{ ...socialIconStyles }}
                    />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
        </Box>
      ) : null}
    </Card>
  );
};

export default CommunityLinks;
